(() => {
  const cleanText = (text) => text.replace(/\b(\d+)\.0\b/g, '$1');

  const cleanVisibleTextNodes = (root) => {
    if (!root) return;

    if (root.nodeType === Node.TEXT_NODE) {
      const cleaned = cleanText(root.nodeValue);
      if (cleaned !== root.nodeValue) root.nodeValue = cleaned;
      return;
    }

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const textNodes = [];
    while (walker.nextNode()) textNodes.push(walker.currentNode);

    textNodes.forEach((textNode) => {
      const cleaned = cleanText(textNode.nodeValue);
      if (cleaned !== textNode.nodeValue) textNode.nodeValue = cleaned;
    });
  };

  const cleanProductSizes = () => {
    document
      .querySelectorAll(
        "variant-selects .product-form__input--pill label, variant-selects .product-form__input--dropdown option, variant-selects [data-selected-value]"
      )
      .forEach(cleanVisibleTextNodes);
  };

  cleanProductSizes();

  document.addEventListener('variant:change', cleanProductSizes);
  document.addEventListener('change', cleanProductSizes);

  const observer = new MutationObserver(cleanProductSizes);
  observer.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();
